<template>
    <tr v-if="column">
        <th>
            &nbsp;
        </th>
        <template v-for="(item, index) in column">
            <th v-if="item.key && item.head" :key="index" :id="item.key" :class="item.class" @click="sort(item.key)">
                <span :class="iconClass">
                    {{ item.head }}
                </span>
            </th>
            <th v-else :key="index" :id="item.key" :class="item.class">
                &nbsp;
            </th>
        </template>
        <th>
            &nbsp;
        </th>
    </tr>
</template>

<script>
    "use strict";

    export default {
        "props": {
            "column": {
                "required": false,
                "type": Array,
            },
            "list": {
                "required": true,
                "type": Array,
            },
            "option": {
                "required": false,
                "type": Object,
            },
        },
        data() {
            return {
                "iconClass": "icon-sort",
                "sortTypeToggle": true,
                "sortTypeToggleKey": "",
            };
        },
        "watch": {
            "list": function() {
                this.changeList();
            },
        },
        // mounted() {
        //     this.changeList();
        // },
        "methods": {
            changeList() {
                let key = "";
                if (this.column) {
                    key = this.column[0].key;
                }
                if (this.option) {
                    if (this.option.key) {
                        key = this.option.key;
                    }
                }
                this.resetSortTypeToggle();
                this.resetSortClass();
                this.setIconClass();
                this.sort(key);
            },
            resetSortTypeToggle() {
                this.sortTypeToggle = true;
                this.sortTypeToggleKey = "";
            },
            resetSortClass() {
                for (let item of this.column) {
                    if (item.key) {
                        const th = document.getElementById(item.key);
                        th.classList.remove("is-asc");
                        th.classList.remove("is-desc");
                    }
                }
            },
            setIconClass() {
                if (this.option) {
                    this.iconClass = this.option.icon ? this.option.icon : this.iconClass;
                }
            },
            setSortType(key) {
                const type = this.option.type ? this.option.type : "asc";
                if (this.sortTypeToggleKey === key) {
                    this.sortTypeToggle = !this.sortTypeToggle;
                } else if (this.sortTypeToggle && !this.sortTypeToggleKey && type === "asc") {
                    this.sortTypeToggle = true;
                } else {
                    this.sortTypeToggle = false;
                }
                this.sortTypeToggleKey = key;
                return this.sortTypeToggle ? "asc" : "desc";
            },
            setSortMode(key) {
                const number = this.option.number ? this.option.number : [];
                let mode = "";
                if (number) {
                    for (let i in number) {
                        if (key === number[i]) {
                            mode = "number";
                        }
                    }
                }
                return mode;
            },
            setSortClass(key, type) {
                const th = document.getElementById(key);
                th.classList.add(`is-${type}`);
            },
            sort(key) {
                const list = JSON.parse(JSON.stringify(this.list));
                const type = this.setSortType(key);
                const mode = this.setSortMode(key);
                let compare = null;
                this.resetSortClass();
                this.setSortClass(key, type);
                if (mode === "number") {
                    if (type === "desc") {
                        compare = (a, b) => b[key] - a[key];
                    } else {
                        compare = (a, b) => a[key] - b[key];
                    }
                } else {
                    compare = (a, b) => {
                        const A = a[key] ? a[key] : " ";
                        const B = b[key] ? b[key] : " ";
                        if (A < B) {
                            if (type === "desc") {
                                return 1;
                            } else {
                                return -1;
                            }
                        } else if (A > B) {
                            if (type === "desc") {
                                return -1;
                            } else {
                                return 1;
                            }
                        }
                        return 0;
                    };
                }
                this.$emit("sort-list", list.sort(compare));
            },
        },
    };
</script>

<style lang="scss" scoped>
    table {
        tr {
            .is-asc {
                .icon-sort,
                .icon-sort--right {
                    &::before {
                        border-right-color: #4c4c4c;
                        border-top-color: #4c4c4c;
                    }
                }
                .icon-sort--triangle,
                .icon-sort--triangle--right {
                    &::before {
                        border-bottom-color: #4c4c4c;
                    }
                }
            }
            .is-desc {
                .icon-sort,
                .icon-sort--right {
                    &::after {
                        border-right-color: #4c4c4c;
                        border-top-color: #4c4c4c;
                    }
                }
                .icon-sort--triangle,
                .icon-sort--triangle--right {
                    &::after {
                        border-top-color: #4c4c4c;
                    }
                }
            }
        }
    }
</style>
